export const themes = {
  colors: {
    background: "#f8f3f0",
    backgroundSecondary: "#a9a35f",
    filled: "#d32b39",
    attention: "#ecc100",
    caution: "#fff100",
    primary: "#0d5ca7",
    gray200: "#ebebeb",
    disabled: "#E0E0E0",
    text: "#212121",
    border: "#BDBDBD",
    white: "#FDFDFD",
    black: "#2e363b",
    secondary: "#59B1E2",
  },
  textSize: {
    ss: "8px",
    s1: "10px",
    s2: "12px",
    s3: "14px",
    m1: "16px",
    m2: "18px",
    m3: "21px",
    l1: "25px",
    l2: "31px",
    l3: "39px",
  },
};
